var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobileSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "me-2",
    width: 14,
    height: 14,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_246",
    "data-name": "Mask Group 246",
    transform: "translate(-8010 17388)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.691,1.679V15.11h8.455V1.679ZM.846,0H10.992a.849.849,0,0,1,.6.246.836.836,0,0,1,.248.594V15.95a.836.836,0,0,1-.248.594.849.849,0,0,1-.6.246H.846a.849.849,0,0,1-.6-.246A.836.836,0,0,1,0,15.95V.839A.836.836,0,0,1,.248.246.849.849,0,0,1,.846,0ZM5.919,12.592a.849.849,0,0,1,.6.246.835.835,0,0,1,0,1.187.85.85,0,0,1-1.2,0,.835.835,0,0,1,0-1.187.849.849,0,0,1,.6-.246Z",
    transform: "translate(8013.081 -17387.479)",
    fill: "#ff295c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileSvg);
export default __webpack_public_path__ + "static/media/mobile-svg.e6d20f6b03398e6c1af3089046638a1b.svg";
export { ForwardRef as ReactComponent };